import { Component, type ErrorInfo, type ReactNode } from 'react';
import { es } from '@/i18n/es';
import { ErrorState } from './ui/ErrorState';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Última red de contención. Si una pantalla explota, mostramos algo
 * accionable en vez de una página en blanco.
 */
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    // En producción esto va al servicio de errores que se configure.
    console.error('[Relatario] error no capturado', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="mx-auto max-w-md px-4 py-16">
        <ErrorState
          title={es.errors.crash.title}
          body={es.errors.crash.body}
          action={{ label: es.errors.crash.action, onClick: () => window.location.reload() }}
          detail={import.meta.env.DEV ? this.state.error.stack : undefined}
        />
      </div>
    );
  }
}
